"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var styles = tslib_1.__importStar(require("./TabItem.style"));

function TabItem(_ref) {
  var index = _ref.index,
      name = _ref.name,
      active = _ref.active,
      onClick = _ref.onClick,
      contrast = _ref.contrast;

  function handleOnClick() {
    onClick({
      index: index,
      name: name
    });
  }

  return jsx_runtime_1.jsx("div", Object.assign({
    css: styles.container
  }, {
    children: jsx_runtime_1.jsx("div", Object.assign({
      role: "button",
      css: [styles.wrapper, active && styles.active, contrast && styles.contrast],
      onClick: handleOnClick
    }, {
      children: name
    }), void 0)
  }), void 0);
}

exports.default = react_1.memo(TabItem);